import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-if.js";

import iconClose from "../../../../images/icons/icon_close.svg";
import googlePlayBadge from "../../../../images/google-play-logo.png";
import appStoreBadge from "../../../../images/app-store-logo.png";

import "./AddLimitModal.style";

class AddLimitModal extends PolymerElement {
  static get template() {
    return html`
      <style include="add-limit-modal-style"></style>

      <template is="dom-if" if="[[isActive]]">
        <div class="add-limit-modal__overlay" on-click="_closeWhenClickingBackdrop">
          <div
            class="add-limit-modal__dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="add-limit-modal-title"
          >
            <button
              type="button"
              class="add-limit-modal__close-btn"
              aria-label="Tutup"
              on-click="_close"
            >
              <img src="[[iconClose]]" alt="" aria-hidden="true" />
            </button>

            <div class="add-limit-modal__copy">
              <template is="dom-if" if="[[aiGeneralCopytext.extra_credits_popup_title]]">
                <h2 id="add-limit-modal-title" class="add-limit-modal__title">
                  [[aiGeneralCopytext.extra_credits_popup_title]]
                </h2>
              </template>
              <template is="dom-if" if="[[aiGeneralCopytext.extra_credits_popup_body]]">
                <p class="add-limit-modal__description">
                  [[aiGeneralCopytext.extra_credits_popup_body]]
                </p>
              </template>
            </div>

            <template is="dom-if" if="[[aiGeneralCopytext.extra_credits_popup_image]]">
              <img
                class="add-limit-modal__illustration"
                src="[[aiGeneralCopytext.extra_credits_popup_image]]"
                alt="Ilustrasi aplikasi Alomedika"
              />
            </template>

            <template is="dom-if" if="[[aiGeneralCopytext.extra_credits_popup_download]]">
              <p class="add-limit-modal__cta-text">
                [[aiGeneralCopytext.extra_credits_popup_download]]
              </p>
            </template>

            <div class="add-limit-modal__store-links">
              <a
                href="https://alomedika.onelink.me/qZen/g6kj8jcr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  class="add-limit-modal__store-image"
                  src="[[googlePlayBadge]]"
                  alt="Google Play"
                />
              </a>
              <a
                href="https://alomedika.onelink.me/qZen/78l3cay5"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  class="add-limit-modal__store-image"
                  src="[[appStoreBadge]]"
                  alt="App Store"
                />
              </a>
            </div>
          </div>
        </div>
      </template>
    `;
  }

  static get properties() {
    return {
      isActive: { type: Boolean, value: false },
      aiGeneralCopytext: { type: Object, value: null },
      iconClose: { type: String, value: iconClose },
      googlePlayBadge: { type: String, value: googlePlayBadge },
      appStoreBadge: { type: String, value: appStoreBadge },
    };
  }

  // Open the add-limit modal from the Tambah Limit button.
  open() {
    this.isActive = true;
  }

  // Close the modal when the user taps the close button.
  _close() {
    this.isActive = false;
  }

  // Close the modal when the user clicks the dark backdrop outside the dialog.
  _closeWhenClickingBackdrop(event) {
    if (event.target !== event.currentTarget) return;
    this._close();
  }
}

customElements.define("add-limit-modal", AddLimitModal);
